var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8137 3.68629C14.8137 3.41015 14.5899 3.18629 14.3137 3.18629L9.81371 3.18629C9.53757 3.18629 9.31371 3.41015 9.31371 3.68629C9.31371 3.96243 9.53757 4.18629 9.81371 4.18629L13.8137 4.18629L13.8137 8.18629C13.8137 8.46243 14.0376 8.68629 14.3137 8.68629C14.5899 8.68629 14.8137 8.46243 14.8137 8.18629L14.8137 3.68629ZM3.35355 15.3536L14.6673 4.03985L13.9602 3.33274L2.64645 14.6464L3.35355 15.3536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6f4cf1132f770f617ee03a6d3a743aea.svg";
export { ForwardRef as ReactComponent };